import { makeStyles, mergeClasses, Text, tokens } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { dolphinTokens } from "../../utils/Theme";

const useStyles = makeStyles({
    contentWrapper: {
        padding: "2rem 1rem"
    },
    refinedWrapper: {
        maxWidth: "1312px",
        margin: "0 auto",
        padding: "3rem 1rem 1.5rem",
        boxSizing: "border-box"
    },
    eyebrow: {
        margin: "0 0 0.75rem",
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: dolphinTokens.colorLightBlue
    },
    h2: {
        "& .highlight": {
            color: dolphinTokens.colorLightBlue,
            "@media (min-width: 1024px)": {
                display: "inline"
            }
        }
    },
    h2Refined: {
        margin: 0
    },
    h4: {
        color: "#869ab8"
    },
    h4Refined: {
        margin: "0.75rem 0 0",
        maxWidth: "40rem",
        color: tokens.colorNeutralForeground2
    },
    h4RefinedCentred: {
        marginLeft: "auto",
        marginRight: "auto"
    }
});

interface ITaglineProps {
    h2Key?: string;
    h4Key?: string;
    eyebrowKey?: string;
    align?: "center" | "start";
    refined?: boolean;
}

export default function Tagline({
    h2Key = "tagline.h2",
    h4Key = "tagline.h4",
    eyebrowKey,
    align = "center",
    refined = false
}: ITaglineProps) {
    const { t } = useTranslation("home");
    const styles = useStyles();

    return (
        <div className={mergeClasses(styles.contentWrapper, refined && styles.refinedWrapper)}>
            {eyebrowKey && (
                <Text block as="p" size={200} weight="bold" align={align} className={styles.eyebrow}>
                    {t(eyebrowKey)}
                </Text>
            )}
            <Text
                block
                as="h2"
                size={800}
                weight={refined ? "semibold" : undefined}
                align={align}
                className={mergeClasses(styles.h2, refined && styles.h2Refined)}
            >
                <span dangerouslySetInnerHTML={{ __html: t(h2Key) }} />
            </Text>
            <Text
                block
                as="h4"
                size={500}
                align={align}
                className={mergeClasses(
                    styles.h4,
                    refined && styles.h4Refined,
                    refined && align === "center" && styles.h4RefinedCentred
                )}
            >
                {t(h4Key)}
            </Text>
        </div>
    );
}